import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const AddressFieldItem = styled(Box)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "left",
  color: theme.palette.text.secondary,
}));
export default AddressFieldItem;
